import type { Statemachine } from 'overmind';
import { statemachine } from 'overmind';

import type { DomainGuid } from '..';

type States =
  | { current: 'BROWSING_SUMMARY' }
  | { current: 'BROWSING_GRID_ELEMENT'; gridElementObjectId: DomainGuid };

type Events =
  | { type: 'BROWSE_SUMMARY' }
  | { type: 'BROWSE_GRID_ELEMENT'; data: DomainGuid };

export type CalculationTacticResultsBrowsingMachine = Statemachine<
  States,
  Events
>;

export const createCalculationTacticResultsBrowsingMachine = () =>
  statemachine<States, Events>({
    BROWSING_GRID_ELEMENT: {
      BROWSE_SUMMARY: () => ({ current: 'BROWSING_SUMMARY' }),
      BROWSE_GRID_ELEMENT: objectId => ({
        current: 'BROWSING_GRID_ELEMENT',
        gridElementObjectId: objectId
      })
    },
    BROWSING_SUMMARY: {
      BROWSE_GRID_ELEMENT: objectId => ({
        current: 'BROWSING_GRID_ELEMENT',
        gridElementObjectId: objectId
      })
    }
  }).create({ current: 'BROWSING_SUMMARY' });
